import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiAlertCircle } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export default function ErrorState({ message, onRetry }) {
  const { t } = useTranslation();
  const isExpired = message?.toLowerCase().includes('expired');
  const isInvalid = message?.toLowerCase().includes('invalid') || message?.toLowerCase().includes('revoked');

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon={FiAlertCircle} className="w-8 h-8 text-red-500" />
        </div>

        <h1 className="text-xl font-bold text-gray-900 mb-2">
          {isExpired
            ? t('manage.linkExpiredTitle', 'Link Expired')
            : isInvalid
              ? t('manage.invalidLinkTitle', 'Invalid Link')
              : t('manage.unexpectedErrorTitle', 'Something went wrong')}
        </h1>

        <p className="text-gray-500 mb-6">
          {isExpired
            ? t('manage.linkExpiredBody', 'This booking management link has expired. Please check your email for an updated link.')
            : isInvalid
              ? t('manage.invalidLinkBody', 'This link is no longer valid. It may have been revoked or already used.')
              : message || t('manage.loadErrorBody', 'We could not load your booking. Please try again.')}
        </p>

        {onRetry && (
          <button
            onClick={onRetry}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
          >
            {t('manage.tryAgain', 'Try Again')}
          </button>
        )}
      </div>
    </div>
  );
}
